module.exports = __webpack_public_path__ + "static/media/Vliegtuig_in_de_lucht.f8417188.mp3";